import type { InternalAxiosRequestConfig } from 'axios';

export default function tokenInterceptor(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  let token: string | undefined;

  const localToken = localStorage.getItem('@CondomobWeb:tokenCondomob');

  if (localToken) {
    const localObject = JSON.parse(localToken);
    token = localObject.token;
  }

  if (
    token &&
    config.url !== '/acesso/social/list' &&
    config.url !== '/acesso/social/login'
  ) {
    config.headers.set('Authorization', `${token}`);
    if (config.method?.toLowerCase() === 'post') {
      config.headers.set(
        'Content-Type',
        'application/x-www-form-urlencoded; charset=UTF-8',
      );
    }
  }
  return config;
}
